<template>
	<div>
		<div class="nutnosti-title">OrelSoft:</div>
		<div v-if="!loading">
			<div
				v-if="results"
				class="cetin-vysledek-card zmensit"
				:style="{ 'background-color': addFn() }"
			>
				Dostupný - {{ add }} - {{ info }}
			</div>
			<div v-else class="cetin-vysledek-card cetin-vysledek-card--bad zmensit">
				Nedostupný
			</div>
		</div>
		<div v-else>
			<tile
				:loading="loading"
				:height="'4'"
				:width="'4'"
				class="loading-icon"
			></tile>
		</div>
	</div>
</template>

<script>
export default {
	name: 'OrelSoftResult',

	props: {
		results: { type: Boolean },
		add: { type: String },
		info: { type: String },
		loading: { type: Boolean },
	},

	data() {
		return {}
	},

	methods: {
	addFn() {
		if (this.add === 'fyzicka') {
			return '#8bfc8d'
		}

		if (this.add === 'obsluzna'){
			return '#ff8000'
		}

		if (this.add === 'teoreticka') {
			return '#828282'
		}
	}
 	},
}
</script>

<style lang="stylus" scoped>
.nutnosti
	display flex
	flex-direction column

.nutnosti-title
	margin-top 20px
	font-size 24px
	font-weight bold
	border-top 1px solid #4CA5F9

.cetin-vysledek-card
	padding 10px
	background-color white;
	border-radius 5px
	margin-right 10px
	margin-bottom 10px

.cetin-vysledek-card--bad
	background-color red;

.zmensit
	width 400px

.loading
	height 50px
	padding 0px

.loading-icon
	height 50px
	padding 0px !important
	margin-top -100px !important

@media (max-width 1000px)
	.zmensit
		width 100%
</style>



// WEBPACK FOOTER //
// src/components/search_provider/results/OrelSoftResult.vue